<template>
  <DashboardLayout>
    <div v-if=hasBizClientAccess([1001]) class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <router-link :to="{ name: 'ViewUnlinkedPaymentVouchers' }"
        class="mb-0 main-identifier fw-semibold text-decoration-none">
        Payment Vouchers Without Warrant
      </router-link>
      <span class="material-symbols-outlined">keyboard_arrow_right</span>
      <p class="mb-0 sub-identifier">Link Payment Voucher</p>
    </div>
    <div v-if=hasBizClientAccess([1000]) class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <router-link :to="{ name: 'ViewUnlinkedPaymentVouchers' }"
        class="mb-0 main-identifier fw-semibold text-decoration-none">
        View Unlinked PVs
      </router-link>
      <span class="material-symbols-outlined">keyboard_arrow_right</span>
      <p class="mb-0 sub-identifier">Link Payment Voucher</p>
    </div>

    <div class="d-flex justify-content-center mb-5">

      <div class="form-outer">
        <form>
          <div class="crud-form position-relative">

            <div class="form-inner mb-2">
              <div class="form-header d-flex justify-content-between align-items-center">
                <h1 class="mb-0">Unlinked Payment Voucher</h1>
              </div>

              <div class="form-body position-relative">
                <div v-if="loadingDetails" class="loading-overlay text-center">
                  <div class="spinner-border text-primary" role="status" aria-hidden="true"></div>
                  <p class="mt-2 mb-0 text-muted">Loading payment voucher details...</p>
                </div>
                <!-- Header Info -->
                <div class="row mb-3">
                  <div class="pv-header mt-3">
                    <h5 class="mda-title mb-0 text-start">PV No: <span class="pv-no">{{ pvInfo.number || 'N/A' }}</span></h5>
                    <h5 class="mda-title mb-0 text-end">{{ mdaInfo.name || 'N/A' }}</h5>
                  </div>
                </div>

                <!-- Payment Info -->
                <div class="row mb-3 payment-item-wrapper justify-content-center">
                  <div class="row content-wrapper section-border h-100 w-100">
                    <div class="col d-flex">
                      <div class="d-flex flex-column justify-content-center h-100 w-100">
                        <label class="form-label fw-bold fixed-label align-items-center">Beneficiary</label>
                        <p type="text" class="form-control view-only-input text-center" readonly>
                            {{ form.beneficiary || 'N/A' }}
                          </p>
                      </div>
                    </div>
                    <div class="col d-flex">
                      <div class="d-flex flex-column justify-content-center h-100 w-100">
                        <label class="form-label fw-bold fixed-label">Initiated Date</label>
                        <p type="text" class="form-control view-only-input text-center" readonly>
                            {{ formatInitDate(form.initDate) || 'N/A' }}
                          </p>
                      </div>
                    </div>
                    <div class="col d-flex">
                      <div class="d-flex flex-column justify-content-center h-100 w-100">
                        <label class="form-label fw-bold fixed-label">Bank</label>
                        <p type="text" class="form-control view-only-input text-center" readonly>
                            {{ form.bank || 'N/A' }}
                          </p>
                      </div>
                    </div>
                    <div class="col d-flex">
                      <div class="d-flex flex-column justify-content-center h-100 w-100">
                        <label class="form-label fw-bold fixed-label">Gross Amount</label>
                        <input type="text" class="form-control view-only-input text-center"
                            :value="'₦' + form.grossAmount || 0" readonly>
                      </div>
                    </div>
                    <div class="col d-flex">
                      <div class="d-flex flex-column justify-content-center h-100 w-100">
                        <label class="form-label fw-bold fixed-label">Total Deductions</label>
                        <input type="text" class="form-control view-only-input text-center"
                            :value="'₦' + form.deductions || 0" readonly>
                      </div>
                    </div>
                    <div class="col no-border d-flex">
                      <div class="d-flex flex-column justify-content-center h-100 w-100">
                        <label class="form-label fw-bold fixed-label">Net Amount</label>
                        <input type="text" class="form-control view-only-input text-center"
                            :value="'₦' + form.netAmount || 0" readonly>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Payment Info -->
                <div class="row mb-3 mt-4">
                  <div class="col-md-12">
                    <h5 class="mda-title mb-0 text-center fw-semibold">Particulars: <span class="particulars">{{
                      form.particulars ||
                        'N/A' }}</span></h5>
                  </div>
                </div>

                <!-- Deductions -->
                <div class="row mb-3 payment-item-wrapper justify-content-center">
                                        <h5 class="mda-title ms-1 mb-2 text-start">Deductions</h5>
                  <div class="table-responsive">
                    <table class="table table-bordered text-center align-middle">
                      <thead class="table-light">
                        <tr>
                          <th>Deduction</th>
                          <th>Description</th>
                          <!-- <th>Percentage</th> -->
                          <th>Amount (₦)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="deductions.length === 0">
                          <td colspan="4" class="text-muted">No deductions added</td>
                        </tr>
                        <tr v-for="(item, index) in deductions" :key="index"
                          :class="index % 2 === 0 ? 'row-even' : 'row-odd'">
                          <td>
                            {{ item.deduction }}
                          </td>
                          <td>
                            {{ item.description }}
                          </td>
                          <!-- <td> {{ item.percentage }}% </td> -->
                          <td>
                            {{ Number(item.amountReleased || 0).toLocaleString() }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </div>

              </div>

              <!-- Submit Button -->
              <div class="d-flex justify-content-end mt-4">
                <div v-if="canLinkWarrant" class="d-flex justify-content-end">
                  <router-link v-if="linkTargetRoute" :to="linkTargetRoute"
                    class="btn btn-outline-primary export-btn-app me-2" :class="{ disabled: loadingDetails }"
                    aria-live="polite" :aria-label="loadingDetails ? 'Loading...' : 'Link to Warrant'">
                    <span v-if="loadingDetails" class="spinner-border spinner-border-sm me-2" role="status"
                      aria-hidden="true"></span>
                    {{ loadingDetails ? 'Loading...' : 'Link to Warrant' }}
                  </router-link>

                  <button v-else type="button" class="btn btn-outline-primary export-btn-app me-2" disabled
                    aria-live="polite" :aria-label="loadingDetails ? 'Loading...' : 'Link to Warrant'">
                    <span v-if="loadingDetails" class="spinner-border spinner-border-sm me-2" role="status"
                      aria-hidden="true"></span>
                    {{ loadingDetails ? 'Loading...' : 'Link to Warrant' }}
                  </button>
                </div>
              </div>
            </div>

          </div>
        </form>
      </div>
    </div>

  </DashboardLayout>
</template>

<script setup>
import { ref, reactive, onMounted, computed } from 'vue'
import axios from 'axios'
import DashboardLayout from '../layout/DashboardLayout.vue'
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import { useRoute } from 'vue-router';
import { useUserStore } from '@/stores/user';

// const router = useRouter();
const root_api_url = process.env.VUE_APP_API_ROOT_URL

const route = useRoute()
const userStore = useUserStore()
const id = route.params.id || route.query.id
const loadingDetails = ref(false)
const linkTargetRoute = ref(null)

const hasRole = (role) => !!(userStore.profile?.role || {})[role]

const canLinkWarrant = computed(() => {
  return hasRole('qssu') || hasRole('registryOfficer')
})

// reactive computed wrapper around bizClientId
const bizClientId = computed(() => userStore.bizClientId || 1000)

// Check if user has business client access
const hasBizClientAccess = (requiredBizClients) => {
  if (!requiredBizClients || requiredBizClients.length === 0) return true
  return requiredBizClients.includes(bizClientId.value)
}

// Reactive form data
const form = reactive({
  id: '',
  pvMemoId: '',
  memoId: '',
  originatingMda: '',
  approvalAuthority: '',
  natureOfExpenditure: '',
  amountApproved: '',
  purposeOfRequest: '',
  approvedBudgetAmount: '',
  amtReleasedToDate: '',
  balance: '',
  performance: '',
  quarter: '',
  budgetYear: '',
  warrantInitiatedDate: '',
  noOfAppLimitPerQtr: '',
  noOfAuthIssuedInQtr: '',
  noOfAuthLeftInQtr: '',
  qtrAuthLimitAmt: '',
  approvedRecurrentAmount: '',
  approvedCapitalAmount: '',
  approvalBalance: '',
  evalRemarks: '',
  amtRecommended: '',
  sectoralHeadRemarks: '',
  dopRemarks: '',
  dotRemarks: '',
  commissionerRemarks: '',
  orgCode: '',
  permSecRemarks: '',
  warrantInitiatorId: '',
  sectoralHeadId: '',
  sectoralHeadRemarkDate: '',
  dopId: '',
  dopRemarkDate: '',
  permSecId: '',
  permSecRemarksDate: '',
  commissionerId: '',
  commRemarkDate: '',
  issueDate: '',
  initDate: '',
  approvalAuthorityId: '',
  mdaId: '',
  evalApprovedRecurrentAmount: '',
  evalApprovedCapitalAmount: '',
  evalApprovalBalance: '',
  groupTypeId: '',
  memoFileNumber: '',
  particulars: '',
})

const deductions = ref([])
// const economicItems = ref([])

const mdaInfo = reactive({
  name: ''
})


const pvInfo = reactive({
  number: ''
})

const resolveLinkTarget = async (tokenFromCaller) => {
  // if (form.memoId) {
  //   linkTargetRoute.value = { name: 'ViewPVMemo', params: { id: String(form.memoId) } }
  //   return
  // }

  const pvMemoId = form.memoId
  const token = tokenFromCaller || Cookies.get('auth_token')

  if (pvMemoId) {
    try {
      const { data } = await axios.get(`${root_api_url}/appraisal/memo/pvMemo/${pvMemoId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })

      const existingMemoId = Array.isArray(data)
        ? (data[0]?.id || data[0]?.memoId)
        : (data?.id || data?.memoId)

      if (existingMemoId) {
        linkTargetRoute.value = { name: 'ViewMemo', params: { id: String(existingMemoId) } }
        return
      }

      linkTargetRoute.value = {
        name: 'ViewPVMemo',
        params: { id: String(pvMemoId) },
        query: { paymentVoucherId: String(id) }
      }
      return
    } catch (error) {
      linkTargetRoute.value = {
        name: 'ViewPVMemo',
        params: { id: String(pvMemoId) },
        query: { paymentVoucherId: String(id) }
      }
      return
    }
  }

  if (!pvMemoId) {
    if (!id) {
      linkTargetRoute.value = null
      return
    }

    try {
      const { data } = await axios.get(`${root_api_url}/appraisal/memo/pv/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })

      const existingMemoId = Array.isArray(data)
        ? (data[0]?.id || data[0]?.memoId)
        : (data?.id || data?.memoId)

      if (existingMemoId) {
        linkTargetRoute.value = { name: 'ViewMemo', params: { id: String(existingMemoId) } }
        return
      }
    } catch (error) {
      // If memo lookup fails or returns not found, fallback to CreateMemo

      linkTargetRoute.value = { name: 'CreateMemo', query: { paymentVoucherId: String(id) } }
      return
    }

    linkTargetRoute.value = { name: 'CreateMemo', query: { paymentVoucherId: String(id) } }
    return
  }
}

const fetchPaymentVoucher = async () => {
  const token = Cookies.get('auth_token')
  loadingDetails.value = true
  try {
    const { data } = await axios.get(`${root_api_url}/payment/voucher/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    })

    form.beneficiary = data?.payee || ''
    form.paymentDate = data?.paymentDate || ''
    form.initDate = data?.pvInitDate || data?.createdDate || ''
    form.bank = data?.bankName || ''
    form.grossAmount = Number(data?.grossAmount || 0).toLocaleString()
    form.deductions = Number((data?.deductions || []).reduce((sum, item) => sum + Number(item?.amount || 0), 0)).toLocaleString()
    form.netAmount = Number(data?.netAmount || 0).toLocaleString()
    form.particulars = data?.particulars || form.particulars
    form.pvMemoId = data?.pvMemoId ? String(data.pvMemoId) : ''
    form.memoId = data?.memoId ? String(data.memoId) : ''

    pvInfo.number = data?.pvNumber || data?.voucherNumber || 'N/A'
    mdaInfo.name = data?.mdaName || data?.mda || data?.originatingMda || 'N/A'

    deductions.value = (data?.deductions || []).map(item => ({
      deduction: item?.dedTypeName || 'N/A',
      description: item?.dedTypeName || 'N/A',
      percentage: item?.percentage || 0,
      amountReleased: item?.amount || 0,
    }))

    await resolveLinkTarget(token)


  } catch (err) {
    console.error('Error loading payment voucher:', err)
    const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`
    Swal.fire({
      html: `${iconHtmlError}
      <h1 style="font-weight:600;">Error</h1>
      <p>${err?.response?.data?.errorMessage || err?.response?.data?.error || err?.response?.data?.message || 'Failed to load payment voucher. Please try again.'}</p>`,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    });
  } finally {
    loadingDetails.value = false
  }
}

const formatInitDate = (value) => {
  if (!value) return ''

  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value

  const day = date.getDate()
  const month = date.toLocaleString('en-US', { month: 'long' })
  const year = date.getFullYear()

  const getOrdinal = (number) => {
    const remainder = number % 100
    if (remainder >= 11 && remainder <= 13) return `${number}th`
    switch (number % 10) {
      case 1:
        return `${number}st`
      case 2:
        return `${number}nd`
      case 3:
        return `${number}rd`
      default:
        return `${number}th`
    }
  }

  return `${getOrdinal(day)} ${month} ${year}`
}


onMounted(() => {
  fetchPaymentVoucher(),
    document.title = "Link Payment Voucher"
})


</script>

<style scoped>
.loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 20;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  pointer-events: all;
}

.view-only-input {
  border: none !important;
  background-color: transparent;
  padding-left: 0;
  cursor: default;
  pointer-events: none;
  color: #212529;
  font-size: 1rem;
  padding-right: 0;
  margin-right: 1rem;
  margin-bottom: 0.5rem !important;
}

.payment-item-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  /* forces every .col to match the tallest */
}

.payment-item-wrapper .view-only-input,
.payment-item-wrapper input.view-only-input {
  flex: 1;
  /* inputs (and your Approval‐Authority <div>) all grow equally */
  /* for your Approval Authority div: */
  white-space: pre-wrap;
}

.dashboard-layout .payment-item-wrapper {
  margin-top: 20px;
  padding: 0;
}

.dashboard-layout .content-wrapper {
  border: 1px solid var(--border);
  background-color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  padding: 1rem;
}

.dashboard-layout .section-border {
  /* padding: 1rem; */
  border-top: 3px solid #667eea !important;
}


.dashboard-layout .payment-item-wrapper .col {
  /* padding: 0; */
  border-right: 1px solid var(--border);
  /* box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05); */
}

.dashboard-layout .payment-item-wrapper .col.no-border {
  border-right: none !important;
}

.dashboard-layout .payment-item-wrapper .fixed-label {
  min-height: 80px;
  justify-content: center;
  width: auto;
  box-sizing: border-box;
  text-align: center;
  /* all: unset; */
  display: flex;
  margin-bottom: 0;
  flex-shrink: 0;
  /* margin-left: 1rem; */
}


.dashboard-layout .payment-item-wrapper .content-wrapper {
  border: 1px solid var(--border);
  background-color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  /* padding: 1rem; */
}

.dashboard-layout .payment-item-wrapper .content {
  border-bottom: 2px solid var(--border);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  gap: 1rem;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.dashboard-layout .payment-item-wrapper label {
  font-size: 16px;
  padding: .375rem 0 !important;
  margin-bottom: 0px !important;
  padding-bottom: 0.5rem;
  font-weight: 600;
}

.dashboard-layout .payment-item-wrapper .col-md-3.no-border {
  border: none;
}

.dashboard-layout .payment-item-wrapper .col-md-3.no-border label {
  padding: .375rem .75rem;
  margin-bottom: 0px !important;
}

.dashboard-layout .payment-item-wrapper .col-md-2.no-border {
  border: none;
}

.dashboard-layout .payment-item-wrapper .col-md-2.no-border label {
  padding: .375rem .75rem;
  margin-bottom: 0px !important;
}

.dashboard-layout .fixed-label {
  display: flex;
  align-items: center;
  /* vertical center */
  justify-content: center;
  /* horizontal center */
  min-height: 4rem;
  width: 100%;
  padding: 0 0.25rem;
  box-sizing: border-box;
  text-align: center;
}

/* Submit Button */
.btn-submit {
  background-color: #10b981;
  border-color: #10b981;
  color: #ffffff;
  padding: 0.625rem 3rem;
  font-weight: 500;
  border-radius: 4px;
  font-size: 1rem;
}

.btn-submit:hover {
  background-color: #059669;
  border-color: #059669;
  color: #ffffff;
}

.btn-submit:disabled {
  background-color: #9ca3af;
  border-color: #9ca3af;
  cursor: not-allowed;
}

.pv-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}
</style>
